import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { 
    path: 'login', 
    loadChildren: () => import('./login/login-mobile/login-mobile.module').then((m) => m.LoginMobileModule),
    pathMatch: 'full' 
  },
  {
    path: '',
    loadChildren: () => import('./app-mobile-routing/app-mobile-routing.module').then(m => m.AppMobileRoutingModule)
  }, 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
